import requests from "./httpService";

const CareerServices = {
  getAllCareer: async (payload) => {
    return requests.post(`/career/`,payload);
  },
  getAllResumeDownload: async (resumeId) => {
    return requests.get(`/${resumeId}`); // Adjust URL if necessary
  },

  updateStatus: async (id,status)=> {
    return requests.put(`/career/updateStatus/${id}`,status);
  }
  // getAlljobrole: async () => {
  //   return requests.get(`/career/`);
  // }
  ,
   updateCareerStatus: async (id,status)=> {
    return requests.patch(`/career/${id}/status`,status);
  }
};

export default CareerServices;
